import { motion } from "framer-motion";
import { Stethoscope, Syringe, Baby, FlaskConical, ArrowRightLeft, FileText, HeartHandshake, Scissors, ShieldCheck } from "lucide-react";
import { SERVICES } from "../data/content";

const ICONS = { Stethoscope, Syringe, Baby, FlaskConical, ArrowRightLeft, FileText, HeartHandshake, Scissors, ShieldCheck };

export const Services = () => (
  <section id="hizmetler" data-testid="services-section" className="bg-[#F8F7F4] py-24 md:py-32">
    <div className="max-w-[1400px] mx-auto px-6 md:px-10">
      <motion.div
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.9, ease: [0.76, 0, 0.24, 1] }}
        className="mb-16 md:mb-20 max-w-2xl"
      >
        <p className="text-xs uppercase tracking-[0.3em] font-bold text-[#B85C38] mb-5">Hizmetlerimiz</p>
        <h2 className="font-serif font-light text-3xl md:text-5xl tracking-tight leading-none text-[#16281D]">
          Ailenizin her ferdi için <em className="italic text-[#B85C38]">bütüncül</em> sağlık hizmeti
        </h2>
      </motion.div>

      <div className="grid grid-cols-1 md:grid-cols-12 gap-6">
        {SERVICES.map((s, i) => {
          const Icon = ICONS[s.icon];
          return (
            <motion.div
              key={s.title}
              data-testid={`service-card-${i}`}
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.8, delay: (i % 2) * 0.12, ease: [0.76, 0, 0.24, 1] }}
              className={`col-span-1 ${s.span} group relative overflow-hidden rounded-2xl border border-[#16281D]/10 bg-[#EFECE6] p-8 md:p-12 flex flex-col justify-between min-h-[280px] transition-colors duration-500 hover:bg-[#16281D]`}
            >
              {s.image && (
                <img
                  src={s.image}
                  alt={s.title}
                  className="absolute inset-0 w-full h-full object-cover opacity-0 group-hover:opacity-20 transition-opacity duration-700"
                />
              )}
              <div className="relative z-10 w-12 h-12 rounded-full bg-[#C1D3C4] flex items-center justify-center text-[#16281D] group-hover:bg-[#B85C38] group-hover:text-[#F8F7F4] transition-colors duration-500">
                <Icon size={20} strokeWidth={1.5} />
              </div>
              <div className="relative z-10 mt-16">
                <h3 className="font-serif text-2xl md:text-3xl text-[#16281D] group-hover:text-[#F8F7F4] transition-colors duration-500 mb-3">
                  {s.title}
                </h3>
                <p className="text-sm md:text-base text-[#4A5D52] group-hover:text-[#F8F7F4]/70 transition-colors duration-500 leading-relaxed max-w-md">
                  {s.desc}
                </p>
              </div>
            </motion.div>
          );
        })}
      </div>
    </div>
  </section>
);
